var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSilhouette2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2077 4.79102H17.2493V2.87435C17.2493 2.62018 17.1484 2.37643 16.9687 2.1967C16.7889 2.01698 16.5452 1.91602 16.291 1.91602C16.0368 1.91602 15.7931 2.01698 15.6134 2.1967C15.4336 2.37643 15.3327 2.62018 15.3327 2.87435V4.79102H7.66602V2.87435C7.66602 2.62018 7.56505 2.37643 7.38533 2.1967C7.2056 2.01698 6.96185 1.91602 6.70768 1.91602C6.45352 1.91602 6.20976 2.01698 6.03004 2.1967C5.85032 2.37643 5.74935 2.62018 5.74935 2.87435V4.79102H4.79102C4.02852 4.79102 3.29725 5.09392 2.75808 5.63308C2.21892 6.17225 1.91602 6.90352 1.91602 7.66602V8.62435H21.0827V7.66602C21.0827 6.90352 20.7798 6.17225 20.2406 5.63308C19.7014 5.09392 18.9702 4.79102 18.2077 4.79102Z",
    fill: "black",
    fillOpacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91602 18.2077C1.91602 18.9702 2.21892 19.7014 2.75808 20.2406C3.29725 20.7798 4.02852 21.0827 4.79102 21.0827H18.2077C18.9702 21.0827 19.7014 20.7798 20.2406 20.2406C20.7798 19.7014 21.0827 18.9702 21.0827 18.2077V10.541H1.91602V18.2077Z",
    fill: "black",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSilhouette2);
export default __webpack_public_path__ + "static/media/calendar-silhouette 2.7f92571d.svg";
export { ForwardRef as ReactComponent };